import React, { useState } from "react";
import Slider from "react-slick";
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../context/LanguageContext';
import Lightbox from './Lightbox';

const imagesCtx = require.context('../images/rooms', false, /\.(png|jpe?g|svg)$/);
const imageList = imagesCtx.keys().map(k => imagesCtx(k));

function Room() {
    const [lightboxIndex, setLightboxIndex] = useState(null);
    const { isEnLang } = useLanguage();
    const { ref, inView } = useInView();

    const variants = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0 },
    };

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        dotsClass: "slick-dots custom-dots",
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 768,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 640,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    };

    const text = {
        en: {
            title: "Our Rooms at B&B Alma Suite: Comfort and Elegance in Anzio",
            description: "Discover our modern and cozy rooms, ideal for a relaxing vacation. Each room offers a garden view for an immersive nature experience. We guarantee complete privacy in renovated environments with a reduced ecological footprint thanks to eco-friendly solutions."
        },
        it: {
            title: "Le Nostre Camere al B&B Alma Suite: Comfort ed Eleganza a Anzio",
            description: "Scopri le nostre camere moderne e accoglienti, ideali per una vacanza rilassante. Ogni stanza offre una vista sul giardino per un'esperienza immersiva nella natura. Garantiamo completa privacy in ambienti rinnovati con un'impronta ecologica ridotta grazie a soluzioni ecosostenibili."
        }
    };

    const { title, description } = isEnLang ? text.en : text.it;

    return (
        <section id="room">
            <motion.div
                ref={ref}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                variants={variants}
                transition={{ duration: 0.8 }}
                className="title-rooms-anzio l-960"
            >
                <h2>{title}</h2>
                <p>{description}</p>
            </motion.div>

            <div className="rooms">
                <Slider {...settings}>
                    {imageList.map((src, index) => (
                        <div key={index} onClick={() => setLightboxIndex(index)} style={{ cursor: 'pointer' }}>
                            <img
                                src={src}
                                alt={isEnLang
                                    ? `Room B&B Alma Suite Anzio ${index + 1}`
                                    : `Camera B&B Alma Suite Anzio ${index + 1}`}
                            />
                        </div>
                    ))}
                </Slider>
            </div>

            {lightboxIndex !== null && (
                <Lightbox
                    images={imageList}
                    initialIndex={lightboxIndex}
                    onClose={() => setLightboxIndex(null)}
                />
            )}
        </section>
    );
}

const CustomPrevArrow = ({ onClick }) => (
    <button className="slick-prev custom-arrow prev-arrow" onClick={onClick} aria-label="Previous">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </button>
);

const CustomNextArrow = ({ onClick }) => (
    <button className="slick-next custom-arrow next-arrow" onClick={onClick} aria-label="Next">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </button>
);

export default Room;
